import React, { useState } from "react";
import TextInput from "../components/input/TextInput";
import Button from "../components/button/Button";
import IconButton from "../components/button/IconButton";
import { Eye, EyeOff } from "lucide-react";
import pathfinderLogo from "../assets/images/pathfinder-wordmark.svg";

const Login = ({ onLogin }: { onLogin: () => void }) => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState("");

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        setError("");

        if (username.toLowerCase() === "camille.aguilar@azed.gov" && password === "ciVwon-5gygze-cenmib") {
            onLogin();
        } else {
            setError("Invalid username or password");
        }
    };

    return (
        <div className="min-h-screen bg-cloud-tint flex items-center justify-center">
            <div className="w-full max-w-md p-8">
                {/* Header with PathFinder logo */}
                <header className="mb-12 text-center">
                    <img 
                        src={pathfinderLogo} 
                        alt="Pathfinder" 
                        className="h-8 mx-auto mb-8"
                        style={{ filter: "brightness(0)" }}
                    />
                    <h1 className="text-2xl font-bold text-charcoal">ESA Audit Tool Login</h1>
                </header>

                {/* Login Form */}
                <form onSubmit={handleSubmit} className="space-y-6">
                    <TextInput
                        label="Username"
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        placeholder="Enter your username"
                        required
                        autoComplete="username"
                    />

                    <div className="relative">
                        <TextInput
                            label="Password"
                            type={showPassword ? "text" : "password"}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter your password"
                            required
                            autoComplete="current-password"
                            className="pr-12"
                        />
                        <div className="absolute right-3 top-[26px] flex items-center pointer-events-none">
                            <div className="pointer-events-auto">
                                <IconButton
                                    icon={showPassword ? EyeOff : Eye}
                                    variant="ghost"
                                    size="small"
                                    onClick={() => setShowPassword(!showPassword)}
                                    aria-label={showPassword ? "Hide password" : "Show password"}
                                    type="button"
                                />
                            </div>
                        </div>
                    </div>

                    {error && (
                        <div className="text-warning text-sm">
                            {error}
                        </div>
                    )}

                    <Button
                        type="submit"
                        variant="primary"
                        size="large"
                        className="w-full"
                    >
                        Login
                    </Button>
                </form>
            </div>
        </div>
    );
};

export default Login;

